import React from 'react';

import ReactDOM from 'react-dom/client';

import Workspace from '../workspace/Workspace';
import '../shared/styles/index.css';
import '../shared/styles/workspace.scss';

document.addEventListener('DOMContentLoaded', () => {
  const root = ReactDOM.createRoot(document.getElementById('workspace'));
  root.render(<Workspace />);
});
